// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/" + {"594":"about","662":"logo"}[chunkId] + "." + {"594":"5fcb5950","662":"b8866a42"}[chunkId] + ".css"; };